









import { Component, Vue } from 'vue-property-decorator';
import { initWebStore } from './tools/ajax-wrapper';
import { acquireTokenWrapper } from './tools/session';

@Component
export default class App extends Vue {
    async created(){
        let canLog: string | undefined = '';
        canLog = await acquireTokenWrapper();
        if (canLog){
            initWebStore();
        }
    }
    
    get layout() {
        const layout: string | boolean | undefined | null =
            this.$route.meta?.layout;

        if (layout === null || layout === false || layout === '') {
            return false;
        }

        if (typeof layout === 'undefined' || layout === true) {
            return 'base-layout';
        }

        return layout + '-layout';
    }
}
